import { UPDATE_SKU_TREND_WIDGET } from "./actionTypes"

export const updateSkuTrendWidget = data => {
  return {
    type: UPDATE_SKU_TREND_WIDGET,
    payload: data,
  }
}
